import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Modal } from '../modal/Modal.js';
import styles from './ConfirmationModal.module.scss.js';

var ConfirmationModal = function (_a) {
    var _b, _c, _d;
    var title = _a.title, description = _a.description, id = _a.id, onClose = _a.onClose, isOpened = _a.isOpened, ariaDescribedBy = _a["aria-describedby"], isPortalDisabled = _a.isPortalDisabled, children = _a.children, size = _a.size, style = _a.style, className = _a.className;
    return (jsx(Modal, __assign({ onClose: onClose, isOpened: isOpened, isPortalDisabled: isPortalDisabled, "aria-labelledby": id, "aria-describedby": ariaDescribedBy, size: size, className: className, style: style }, { children: jsxs(Modal.Content, __assign({ className: clsx(styles.content, (_b = {},
                _b[styles.contentSmall] = size === 's',
                _b)) }, { children: [jsx("div", __assign({ className: clsx(styles.title, (_c = {},
                        _c[styles.titleSmall] = size === 's',
                        _c)), id: id }, { children: title })), description, jsx("div", __assign({ className: clsx(styles.actions, (_d = {},
                        _d[styles.actionsSmall] = size === 's',
                        _d)) }, { children: children }))] })) })));
};

export { ConfirmationModal };
